// React
import { useTranslation } from "react-i18next";

// MUI
import { Typography, TextField, MenuItem } from "@mui/material";

// Styles
import { styles } from "../styles";

export const PreferredLanguageStep = ({
  preferredLanguage,
  onPreferredLanguageChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography sx={styles.heading}>
        {t("reasonForVisitModal.addPreferredLanguage")}
      </Typography>
      <Typography sx={styles.languageDescription}>
        {t("reasonForVisitModal.preferredLanguageDescription")}
      </Typography>
      <TextField
        select
        value={preferredLanguage}
        onChange={(event) => onPreferredLanguageChange(event.target.value)}
        variant="outlined"
        fullWidth
        label={t("patientForm.preferredLanguageLabel")}
      >
        <MenuItem value="en">{t("languages.english")}</MenuItem>
        <MenuItem value="fr">{t("languages.french")}</MenuItem>
      </TextField>
    </>
  );
};
